import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { IconExternalLink } from '@tabler/icons-react';
import useMemoryGameStore from '../../../store/memoryGameStore';
import { renderMarkdownToReact } from '../../../components/UI/MarkdownText/MarkdownText';
import styles from './FactModal.module.scss';

function SparkleDecor() {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--bs-primary, #029ed4)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-primary animate-pulse"
        >
            <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707m0-12.728l.707.707m11.314 11.314l.707-.707" />
            <circle cx="12" cy="12" r="4" />
        </svg>
    );
}

const FactModal = ({ backdropClassName }) => {
    const { activeFact: factData, closeFactModal: onClose } = useMemoryGameStore();

    if (!factData) return null;

    const fact = factData.fact;
    const hasLink = fact?.linkUrl && fact.linkUrl !== '#';
    const destinationUrl = hasLink ? fact.linkUrl : null;
    const isExternal =
        destinationUrl && (destinationUrl.startsWith('http://') || destinationUrl.startsWith('https://'));

    return (
        <Modal
            isOpen={!!factData}
            toggle={onClose}
            centered
            className="mx-auto"
            contentClassName="border-0 shadow-lg"
            backdrop="static"
            backdropClassName={backdropClassName}
            style={{ maxWidth: '360px' }}
        >
            <ModalBody className="text-center p-4 d-flex flex-column align-items-center gap-3 bg-white text-dark rounded-3">
                <div className="d-flex align-items-center justify-content-center my-1">
                    <SparkleDecor />
                </div>

                <div className="w-100">
                    <h2 className="h5 text-dark mb-2 fw-bold">{fact?.headline || 'Gut gemacht!'}</h2>
                    {fact?.copy && (
                        <p className="small mb-0 text-center" style={{ fontSize: '14px', lineHeight: '1.4' }}>
                            {renderMarkdownToReact(fact.copy)}
                        </p>
                    )}
                </div>

                {fact?.imageUrl && (
                    <div
                        className={`${styles.imageContainer} w-100 rounded-3 overflow-hidden my-1 d-flex align-items-center justify-content-center`}
                    >
                        <img
                            src={fact.imageUrl}
                            alt={fact?.headline || 'Fakt Bild'}
                            className="w-100 h-100 object-fit-cover"
                        />
                    </div>
                )}

                {hasLink ? (
                    <>
                        <Button
                            href={destinationUrl}
                            tag="a"
                            target="_blank"
                            rel="noopener"
                            color="yellow"
                            className="w-100 fw-bold py-2 anl_memory-game--fact-link-btn"
                        >
                            <span className="d-flex align-items-center justify-content-center gap-1">
                                {fact?.linkButtonText || 'Mehr erfahren'}
                                {isExternal && <IconExternalLink size={16} />}
                            </span>
                        </Button>
                        <Button
                            type="button"
                            onClick={onClose}
                            color="dark"
                            outline
                            className="w-100 mt-1 fw-semibold py-2 anl_memory-game--fact-continue-btn"
                        >
                            {fact?.continueButtonText || 'Weiterspielen'}
                        </Button>
                    </>
                ) : (
                    <Button
                        type="button"
                        onClick={onClose}
                        color="yellow"
                        className="w-100 fw-bold py-2 anl_memory-game--fact-continue-btn"
                    >
                        <span className="d-flex align-items-center justify-content-center gap-1">
                            {fact?.continueButtonText || 'Weiterspielen'}
                        </span>
                    </Button>
                )}
            </ModalBody>
        </Modal>
    );
};

export default FactModal;
